// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_zJZkR","fl":"index_fl_JeX2Z","fr":"index_fr_MJLaf","bottomAd":"index_bottomAd_GkBHQ"};